import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './ViewGallery.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';

const ViewGallery = () => {

    useEffect(() => {
        document.title = `View Gallery | Local Bells`;
        document.getElementById('bodywrap').className = 'neviewgall';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };


    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row className='mb-5'>
                                    <Col md={12} lg={12} xl={3} xxl={6}>
                                        <div>
                                            <h3>Nashik Gallery</h3>
                                        </div>
                                    </Col>
                                    <Col md={12} lg={12} xl={9} xxl={6}>
                                        <Row className='vg-top'>
                                            <Col xs={12} md>

                                                <Row className='ldsearch'>
                                                    <Col md={12}>
                                                        <InputGroup className="mb-3">
                                                            <InputGroup.Text id="search" className='lds-left'>
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search.webp'} className="img-fluid" alt="search" />
                                                            </InputGroup.Text>
                                                            <Form.Control
                                                                placeholder="Search images"
                                                                aria-label="search"
                                                                aria-describedby="search"
                                                            />
                                                            <InputGroup.Text id="search" className='lds-right'>
                                                                <Button>
                                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search" />
                                                                </Button>
                                                            </InputGroup.Text>
                                                        </InputGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} md="auto">
                                                <Link to="/neighbour/add-gallery" className='anc-link'>
                                                    <div>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'} className="img-fluid" alt="add-wh" />
                                                        <h6>Add image</h6>
                                                    </div>
                                                </Link>
                                            </Col>
                                            <Col xs={12} md="auto">
                                                <div className='sort-box'>
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="success" id="dropdown-like">
                                                            <h6>Sort By</h6>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sort.webp'} className="img-fluid" alt="sort" />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu className='sort-drop'>
                                                            <h4>Sort By</h4>
                                                            <Dropdown.Item href="#"> Ascending </Dropdown.Item>
                                                            <Dropdown.Item href="#"> Decending </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Ramkund</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ramkund.webp'} className="img-fluid vg-single-img" alt="ramkund" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Panchavati Temple</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/panchavati.webp'} className="img-fluid vg-single-img" alt="panchavati" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Muktidham Mandir</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search.webp'} className="img-fluid vg-single-img" alt="muktidham" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Pandav Leni Caves</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pandavlenicaves.webp'} className="img-fluid vg-single-img" alt="pandavlenicaves" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Shree Kaalaram Mandir</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/shreekaalarammandir.webp'} className="img-fluid vg-single-img" alt="shreekaalarammandir" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Pandav Leni Caves</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pandavlenicavesorg.webp'} className="img-fluid vg-single-img" alt="pandavlenicavesorg" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>

                                        <div>
                                            <h6 className='fw-500'>Sita Gufa</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sitagufa.webp'} className="img-fluid vg-single-img" alt="sitagufa" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={4} xxl={3} className='gallry-single'>
                                        <div>
                                            <h6 className='fw-500'>York Winery & Tasting Room</h6>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/yorkwinery.webp'} className="img-fluid vg-single-img" alt="yorkwinery" />
                                            <div class="vg-single-bot">
                                                <div>
                                                    <h6>Posted By : <span className='fw-500'>Saurabh P</span> 11 Days Ago</h6>
                                                </div>
                                                <div onClick={(e) => {
                                                    const img = e.currentTarget.querySelector('img');
                                                    const liked = img.getAttribute('data-liked') === 'true';
                                                    img.setAttribute('src', liked ? '../assets/images/heart.webp' : '../assets/images/heart-filled.webp');
                                                    img.setAttribute('data-liked', liked ? 'false' : 'true');
                                                }} style={{ cursor: 'pointer' }}>
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/heart.webp'}
                                                        className="img-fluid vg-icn"
                                                        alt="heart"
                                                        data-liked="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section >
        </>
    )
}

export default ViewGallery;


